/**
 * Pengeregning. Databasen er autoritativ (NUMERIC), men beregninger sker her, saa
 * frontend og backend altid naar samme tal.
 *
 * Alle beloeb rundes til to decimaler paa hvert trin. Vi summerer ikke urundede
 * mellemresultater, fordi fakturaens total skal kunne afstemmes mod summen af de linjer
 * kunden faktisk ser.
 */

/** Runder til to decimaler. Half-up, med korrektion for binaer flydende-komma-drift. */
export function round2(value: number): number {
  if (!Number.isFinite(value)) throw new Error(`round2 fik en ikke-finit vaerdi: ${value}`);
  return Math.round((value + Number.EPSILON * Math.sign(value) * Math.abs(value)) * 100) / 100;
}

/** Summerer og runder. Tom liste giver 0, ikke NaN. */
export function sumMoney(values: readonly number[]): number {
  return round2(values.reduce((total, value) => total + value, 0));
}

/** antal x enhedspris, afrundet. */
export function lineTotal(quantity: number, unitPrice: number): number {
  return round2(quantity * unitPrice);
}

/**
 * Division der aldrig kaster og aldrig giver NaN eller Infinity.
 * Bruges til procentberegninger hvor naevneren kan vaere 0 - fx en kontrakt med
 * kontraktsum 0, som ellers ville vise "NaN %" i UI.
 */
export function safeDivide(numerator: number, denominator: number, fallback = 0): number {
  if (denominator === 0 || !Number.isFinite(denominator) || !Number.isFinite(numerator)) {
    return fallback;
  }
  return numerator / denominator;
}

/** Procentdel af et hele, med 0 som svar naar helheden er 0. */
export function percentageOf(part: number, whole: number): number {
  return round2(safeDivide(part, whole) * 100);
}
